import ModuleCard from './component'
export default ModuleCard
